import { PlanState } from "../types"
import { SelectedFieldAction, SelectedFieldObservation } from "./types"

export function updateAction(state: PlanState, { obs, key, text }: { obs: SelectedFieldObservation, key: number, text: string }) {

    const { observations: { obsActionsProvider } } = state

    let action = obs.actions.find(a => a.key === key)

    if (!action) {
        return state
    }

    const actions = obsActionsProvider(obs.observationId)

    const actionId = actions
        ? actions.find(o => o.text === text)?.id
        : undefined

    action = {
        ...action,
        actionId,
        text
    }

    return _update(state, obs, action)

}

export function addNewAction(state: PlanState, obs: SelectedFieldObservation): PlanState {

    const { selectedField } = state
    const { keyAllocator } = selectedField

    return _update(state, obs, createNewAction(keyAllocator))

}

function _update(state: PlanState, obs: SelectedFieldObservation, action: SelectedFieldAction): PlanState {

    const { selectedField } = state

    const actions = obs.actions.map(a => a.key !== action.key ? a : action)

    if (actions.indexOf(action) < 0) {
        actions.push(action)
    }

    const observations = selectedField.observations.map(o => o !== obs
        ? o
        : {
            ...o,
            actions
        }
    )


    return {
        ...state,
        selectedField: {
            ...selectedField,
            activeObservation: {
                observation: obs.key,
                action: action.key
            },
            observations
        }
    }

}

export function createNewAction(keyAllocator: () => number) {

    return {
        key: keyAllocator(),
        actionId: undefined,
        text: undefined,
        new: true,
        deleted: false,
        updated: false,
        valid: true
    }
}
